<template>
  <div id="app">
    <v-app id="inspire" v-scroll="onScroll">
      <layout v-if="hasUserSession"></layout>
      <v-snackbar v-model="snackbar" :color="color">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            {{ $t('message.common.close') }}
          </v-btn>
        </template>
      </v-snackbar>
      <v-main>
        <v-container fluid class="container--app pa-0">
          <router-view></router-view>
        </v-container>
        <v-fab-transition>
          <v-btn fab bottom right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
            <v-icon dark>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-main>
      <!-- <v-fade-transition>
        <v-alert prominent v-if="getNewContentAvailable" transition="scale-transition" type="info" class="pa-2" style="position: fixed;bottom:-10px;z-index: 100;">
          <v-row align="center">
            <v-col>{{ $t('message.common.newUpdate') }}</v-col>
            <v-col class="shrink">
              <v-btn outlined @click="loadUpdateContent">{{ $t('message.common.refresh') }}</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-fade-transition> -->
      <v-dialog v-model="showInstalliOS" max-width="400px" persistent class="mt-0">
        <v-card>
          <v-card-title>
            <v-flex xs11>
              <h3>Install</h3>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
              <v-icon @click="showInstalliOS = false">mdi-close</v-icon>
            </v-flex>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
            <v-layout row wrap>
              <v-flex xs12>
                Install this application on your home screen for quick and easy access when you’re on the go.
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"></v-divider>
            <v-layout>
              <v-flex xs12 class="mt-2 text-xs-center">
                <b>Just tap <v-icon color="#59a7ff">mdi-open-in-app</v-icon> then “Add to Home Screen”</b>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import Layout from './components/Layout'
import { api } from './plugins/axios_settings'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/services/goto'
export default {
  name: 'App',
  data () {
    return {
      showScrollToTop: false,
      text: '',
      snackbar: false,
      color: '',
      drawer: false,
      loading: false,
      showInstalliOS: false
    }
  },
  components: {
    Layout
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'getNewContentAvailable']),
    hasUserSession () {
      return this.isAuthenticated
    }
  },
  created () {
    let authToken = this.$cookie.get(process.env.VUE_APP_TOKEN)
    let getActiveuser = this.$cookie.get(process.env.VUE_APP_USER)
    let user = getActiveuser ? JSON.parse(getActiveuser) : {}
    if (this.$route.path !== '/login') {
      if (!authToken) {
        this.$store.dispatch('logout')
        this.$cookie.delete(process.env.VUE_APP_TOKEN)
      } else this.$store.commit('setAuth', { authToken, user })
    }
  },
  watch: {
    getNewContentAvailable (val) {
      if (val) this.$store.dispatch('reloadNewContent')
    }
  },
  mounted () {
    this.$root.$on('snackbar', data => {
      this.snackbar = data.snackbar
      this.color = data.color
      this.text = data.text
    })
    let showniOSBanner = window.localStorage.getItem('shownInstallBanner') || false
    if (this.isIos() && !this.isInStandaloneModeIos() && !showniOSBanner) {
      this.showInstalliOS = true
      window.localStorage.setItem('shownInstallBanner', true)
    } else {
      this.showInstalliOS = false
    }
  },
  beforeMount () {
    let text = this.$t('message.login.authFailed')
    let apis = [ api ]
    apis.forEach(element => {
      element.interceptors.response.use(
        (response) => {
          return Promise.resolve(response)
        },
        (error) => {
          this.$store.commit('hideLoader')
          if (error.response) {
            let exception = error.response
            if (error.response.status === 409) {
              setTimeout(() => {
                window.location.reload()
              })
            } else {
              if (error.response.data) exception = `Status Code : ${error.response.status}, Message : ${error.response.data}`
              else exception = `Status Code : ${error.response.status}, Message : ${error.response.statusText}`
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(exception) })
              if (error.response.status === 401) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text })
                this.$store.dispatch('logout')
                this.$router.push('/login').catch(() => {})
              }
            }
          } else {
            let text = error.message
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(text) })
          }
          return Promise.reject(error)
        }
      )
    })
  },
  methods: {
    isIos () {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    },
    isInStandaloneModeIos () {
      return ('standalone' in window.navigator) && (window.navigator.standalone)
    },
    confirmDelete () {
      this.loading = true
      let model = this.deletePayload
      this.$store.dispatch('deleteRecordHandler', model)
        .then(() => {
          this.$root.$emit('deleteSuccess', model.module)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
    },
    scrollToTop () {
      goTo(0)
    },
    loadUpdateContent () {
      this.$store.dispatch('reloadNewContent')
    }
  }
}
</script>
<style lang="scss">
  @import './assets/css/app.scss';
  .theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {
    color: black !important;
  }
  .v-card__subtitle, .v-card__text {
    font-size: 1rem !important;
  }
  .pickProducts .productRow:nth-child(even) {
    background: #eeeeee;
  }
  .productInfo {
    font-size: 0.9em;
    font-style: italic;
  }
  .productRow {
    height: 45px;
  }
</style>
